import { useEffect, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { Select, SelectInstance } from '@any-ui-react/select';
import classNames from 'classnames';

import { Option } from '../../types/basic';

export interface OperatorSelectorProps {
  operators?: string[];
  value?: string;
  onSelect: (value?: string) => void;
  compact?: boolean;
  operatorLabels?: Record<string, string>;
  disabled?: boolean;
}

export const OperatorSelector = ({
  operators = [],
  value,
  onSelect,
  compact,
  operatorLabels,
  disabled = false,
}: OperatorSelectorProps) => {
  const { t } = useTranslation('crm');
  const ref = useRef<SelectInstance<Option>>(null);

  const options = useMemo(() => {
    return operators.map((operator) => ({
      label: operatorLabels?.[operator] || t('crm.conditionBuilder.operator.options', { operator }),
      value: operator,
    }));
  }, [operators, t, operatorLabels]);

  useEffect(() => {
    if (!value) {
      ref.current?.clearValue();
    }
  }, [value]);

  return (
    <Select
      ref={ref}
      placeholder={t('crm.conditionBuilder.operator.placeholder')}
      className={classNames({
        'w-full': compact,
        'min-w-48': !compact,
      })}
      options={options}
      value={value}
      onChange={(option) => {
        onSelect(option?.value);
      }}
      disabled={disabled}
    />
  );
};
